import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const InstagramIcon = ({ className = '', color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height='23'
            viewBox='0 0 23 23'
            width='23'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M6.67608 0.000488281C2.9994 0.000488281 0 2.99989 0 6.67657V16.3313C0 20.0011 2.9994 23.0005 6.67608 23.0005H16.3308C20.0006 23.0005 23 20.0011 23 16.3244V6.67657C23 2.99989 20.0006 0.000488281 16.3239 0.000488281H6.67608ZM6.67608 1.76972H16.3239C19.0469 1.76972 21.2308 3.95361 21.2308 6.67657V16.3244C21.2308 19.0474 19.0469 21.2313 16.3308 21.2313H6.67608C3.95312 21.2313 1.76923 19.0474 1.76923 16.3313V6.67657C1.76923 3.95361 3.95312 1.76972 6.67608 1.76972ZM18.5769 3.53895C18.0862 3.53895 17.6923 3.93288 17.6923 4.42356C17.6923 4.91425 18.0862 5.30818 18.5769 5.30818C19.0676 5.30818 19.4615 4.91425 19.4615 4.42356C19.4615 3.93288 19.0676 3.53895 18.5769 3.53895ZM11.5 5.30818C8.09285 5.30818 5.30769 8.09334 5.30769 11.5005C5.30769 14.9076 8.09285 17.6928 11.5 17.6928C14.9072 17.6928 17.6923 14.9076 17.6923 11.5005C17.6923 8.09334 14.9072 5.30818 11.5 5.30818ZM11.5 7.07741C13.9534 7.07741 15.9231 9.04706 15.9231 11.5005C15.9231 13.9539 13.9534 15.9236 11.5 15.9236C9.04657 15.9236 7.07692 13.9539 7.07692 11.5005C7.07692 9.04706 9.04657 7.07741 11.5 7.07741Z'
                fill={color}/>
        </svg>


    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default InstagramIcon;
